if (!customElements.get('cut-off-time')) {
  customElements.define(
    'cut-off-time',
    class CutOffTime extends HTMLElement {
      constructor() {
        super();
        this.intervalId = null;
        this.init();
      }

      init() {
        this.cutOffTime = this.dataset.cutOffTime;
        this.activeElement = this.querySelector('.js-cut-off-time-active');
        this.expiredElement = this.querySelector('.js-cut-off-time-expired');
        this.containerElement = this.querySelector('.product__inventory');

        if (!this.cutOffTime || !this.activeElement || !this.expiredElement) {
          return;
        }

        // Get texts from data attributes
        this.activeText = this.activeElement.dataset.cutOffTimeText;
        this.expiredText = this.expiredElement.dataset.cutOffTimeText;

        // Parse cutoff time
        const timeParts = this.cutOffTime.split(':');
        this.cutOffHour = parseInt(timeParts[0], 10);
        this.cutOffMinute = parseInt(timeParts[1], 10) || 0;

        // Update immediately
        this.updateCountdown();

        // Update every second
        this.startTimer();
      }

      startTimer() {
        // Clear any existing interval
        if (this.intervalId) {
          clearInterval(this.intervalId);
        }

        // Update every second
        this.intervalId = setInterval(() => {
          this.updateCountdown();
        }, 1000);
      }

      updateCountdown() {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        // Create target time for today
        const targetTime = new Date(today.getTime() + (this.cutOffHour * 60 + this.cutOffMinute) * 60000);

        // Check if current time is past today's cutoff
        const isPastCutoff = now >= targetTime;

        // If past today's cutoff, show expired message until midnight
        if (isPastCutoff) {
          // Hide active element, show expired element
          this.activeElement.classList.add('hidden');
          this.expiredElement.classList.remove('hidden');

          // Update container classes for styling
          if (this.containerElement) {
            this.containerElement.classList.remove('product__inventory--in-stock');
            this.containerElement.classList.add('product__inventory--out-of-stock');
          }

          // Update expired element text if needed
          if (this.expiredText) {
            const cutOffTimeFormatted = 
              (this.cutOffHour < 10 ? '0' : '') + this.cutOffHour + ':' + 
              (this.cutOffMinute < 10 ? '0' : '') + this.cutOffMinute;
            const finalExpiredText = this.expiredText.replace('[[time]]', cutOffTimeFormatted);
            this.expiredElement.textContent = finalExpiredText;
          }
          return; // Don't update countdown
        }

        // Before today's cutoff, show active element with countdown
        this.activeElement.classList.remove('hidden');
        this.expiredElement.classList.add('hidden');

        // Update container classes for styling
        if (this.containerElement) {
          this.containerElement.classList.remove('product__inventory--out-of-stock');
          this.containerElement.classList.add('product__inventory--in-stock');
        }

        const timeDiff = targetTime - now;

        const hours = Math.floor(timeDiff / (1000 * 60 * 60));
        const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

        // Format time with leading zeros
        const formattedTime = 
          (hours < 10 ? '0' : '') + hours + ':' +
          (minutes < 10 ? '0' : '') + minutes + ':' +
          (seconds < 10 ? '0' : '') + seconds;

        // Replace [[time]] in the active text with the countdown
        if (this.activeText && this.activeText.includes('[[time]]')) {
          const finalText = this.activeText.replace('[[time]]', formattedTime);
          this.activeElement.textContent = finalText;
        } else {
          // Fallback to just showing the countdown
          this.activeElement.textContent = formattedTime;
        }
      }

      disconnectedCallback() {
        if (this.intervalId) {
          clearInterval(this.intervalId);
        }
      }
    }
  );
}

